// @ts-nocheck

import { memo, FC, useMemo } from 'react'
import { Input } from '@chakra-ui/react'

import NumberFilterField from './components/NumberFilterField'
import InputFilterField from './components/InputFilterField'
import TextareaFilterField from './components/TextareaFilterField'
import BooleanFilterField from './components/BooleanFilterField'
import DateInputFilterField from './components/DateInputFilterField'
import DatetimeInputFilterField from './components/DatetimeInputFilterField'
import { UseFormRegister } from 'react-hook-form'

type PossibleFields = {
  [key: string]: JSX.Element
}

export type DynamicFieldProps = {
  name: string
  register: UseFormRegister<any>
}

type Props = DynamicFieldProps & {
  register: UseFormRegister<any>
  type: string | 'TEXT' | 'STRING' | 'DATE' | 'DATETIME' | 'NUMBER' | 'BOOLEAN'
}

const DynamicAdvancedFilterInput: FC<Props> = ({ register, name, type }) => {
  const Component = useMemo(() => {
    const possibleFields: PossibleFields = {
      STRING: <InputFilterField register={register} name={name} />,
      TEXT: <TextareaFilterField register={register} name={name} />,
      NUMBER: <NumberFilterField register={register} name={name} />,
      BOOLEAN: <BooleanFilterField register={register} name={name} />,
      DATE: <DateInputFilterField register={register} name={name} />,
      DATETIME: <DatetimeInputFilterField register={register} name={name} />,
    }

    if (!type) return <Input register={register} name={name} />

    return possibleFields[type]
  }, [type])

  return Component
}

export default memo(DynamicAdvancedFilterInput)
